export const searchStyling = {
    width: 240,
    borderRadius: 5,
    height: 30,
};

export const boxSearchStyling = {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 0,
    border: '#767676',
};

export const iconStyling = {
    fontSize: '20px',
    color: '#6b6b6b',
    margin: 0,
    _hover: { bg: '#c4c4c4' },
};
